<template>
  <div class="outer">
    <!-- 发展历程 -->
    <div class="history">
      <div class="topTitle animate__animated animate__zoomIn">
        <div class="chinese">发展历程</div>
        <div class="english">DEVELOPMENT HISTORY</div>
      </div>
      <img src="@/assets/img/classic/history_bg.png" />
      <vueSeamlessScroll class="contentHist" :data="list" :class-option="defineScroll">
        <template v-for="(item, index) in list">
          <template v-if="index % 2 === 0">
            <div class="item">
              <div class="message">
                <!-- <span>{{ item.startTime }}-{{ item.endTime }}年</span> -->
                <span>{{ item.startTime }}-{{ item.endTime }}
                  <!-- 处理年份不为number的情况 :如2023-至今-->
                  <!-- <span style="display: inline;" v-if="parseInt(item.endTime)">年</span> -->
                </span>
                <p>
               {{ isEnglish?'':'&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' }}    {{ item.content }}
                </p>
              </div>
              <img class="point_line" src="@/assets/img/point_line.png" alt="">
              <img v-if="index != list.length - 1" src="@/assets/img/lt_rb.png" alt="">
              <div v-else class="empty"></div>
            </div>
          </template>
          <template v-else>
            <div class="item right">
              <img class="point_line" src="@/assets/img/point_line.png" alt="">
              <img v-if="index != list.length - 1" src="@/assets/img/rt_lb.png" alt="">
              <div v-else class="empty"></div>
              <div class="message">
                <span>{{ item.startTime }}-{{ item.endTime }}
                  <!-- <span style="display: inline;" v-if="parseInt(item.endTime)">年</span> -->
                </span>
                <p>
                     {{ isEnglish?'':'&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' }}{{ item.content }}                </p>
              </div>
            </div>
          </template>
        </template>
      </vueSeamlessScroll>
    </div>
  </div>
</template>
  
<script>
import vueSeamlessScroll from "vue-seamless-scroll";

export default {
  name: "Development",
  props: ['list'],
  components: {
    vueSeamlessScroll
  },
  data () {
    return {
    };
  },
  computed: {
       isEnglish() {
      return this.$store.state.language === 'English';
    },
    defineScroll () {
      return {
        step: 1, // 数值越大速度滚动越快
        limitMoveNum: 7, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: false, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
      };
    },
  },
  mounted () {
  },
  methods: {
  },
};
</script>
  
<style lang="scss" scoped>
.topTitle {
  color: #024094;
  padding: 80px;
  padding-bottom: 0;
  text-align: center;
}

.history {
  height: 1080px;
  position: relative;
  overflow: hidden;

  img {
    // width: 3000px;
    width: 100%;
    position: absolute;
    bottom: 70px;
    left: 0;
    z-index: -1;
  }

  .contentHist {
    // width: 700px;
    width: 1380px;
    position: relative;
    z-index: 9;
    margin: 0 auto;
    overflow: hidden;

    .item {
      display: flex;
      text-align: left;
      height: 117px;
      width: 50%;
      position: relative;
      right: 0;
      top: 80px;

      .message {
        width: 100%;
        position: relative;
        top: -80px;
     p{
      font-size: 16px !important;
     }
      }

      img {
        width: 72px;
        // height: 100%;
        height: 117px;
        position: relative;
      }

      // 最后一个时间节点不显示img图片，加一个空元素撑开内容避免样式混乱
      .empty {
        width: 72px;
        height: 117px;
        margin-right: 40px;
      }
    }

    .right {
      left: 570px;

      span {
        text-align: left;
      }

      .message {
        left: 70px;
      }

      .point_line {
        left: 100px;
        transform: rotateY(180deg);
      }
    }

    .bottom {
      .message {
        left: 130px;
      }
    }

    span {
      display: block;
      text-align: right;
      font-size: 20px;
      font-family: Source Han Sans CN;
      color: #0f1928;
    }

    p {
      width: 570px;
      font-size: 14px;
      font-family: Source Han Sans CN;
      line-height: 20px;
      color: #555;
    }

    .point_line {
      height: 26px !important;
      position: absolute;
      top: -80px;
      left: 20px;
      z-index: 9;
    }
  }
}
</style>
  